var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1.70313C1.04973 1.89646 1.17822 2.03455 1.31512 2.17117C2.89586 3.74884 4.47409 5.32902 6.05575 6.9058C6.13134 6.98118 6.1311 7.01901 6.05563 7.09424C4.47393 8.67093 2.8956 10.251 1.31474 11.8286C1.17782 11.9653 1.04941 12.1034 1 12.2969V12.5078C1.07821 12.7577 1.24127 12.9228 1.49219 13H1.72656C1.91812 12.9383 2.05621 12.8043 2.19452 12.6659C3.88455 10.9739 5.57591 9.28314 7.26855 7.59372C7.40962 7.45291 7.54799 7.31345 7.60938 7.11719V6.88281C7.54701 6.68718 7.41018 6.5467 7.26888 6.40567C5.57613 4.71646 3.8848 3.0258 2.19491 1.33373C2.05649 1.19509 1.91777 1.06209 1.72656 1L1.49219 1C1.44651 1.01927 1.40059 1.03797 1.3552 1.05787C1.16291 1.14212 1.06862 1.3067 1 1.49219V1.70313Z",
    fill: "#ADABAB",
    stroke: "#ADABAB",
    strokeWidth: 0.2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcView);
export default __webpack_public_path__ + "static/media/ic-view.375f8ad9422eb18d80d7dc847adc89d4.svg";
export { ForwardRef as ReactComponent };